var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSongbooksLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.5 6.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #faa41c;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.6,1.1H1.5v1.3h3.9c.6,0,1,.1,1.2.3s.3.6.3,1.2v.8c0,.6-.1.9-.3,1.2s-.6.3-1.2.3H1.5c-.6,0-1-.1-1.2-.3s-.3-.6-.3-1.2v-.2l1.3-.3v.7h4.4v-1.4H1.8c-.6,0-1-.1-1.2-.3s-.3-.6-.3-1.2v-.7c0-.6.1-.9.3-1.2s.6-.3,1.2-.3h3.5c.6,0,1,0,1.2.3s.3.6.3,1.1h0c0,.1-1.3.4-1.3.4v-.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.6,1.5c0-.6.1-.9.3-1.2s.6-.3,1.2-.3h4.6c.6,0,1,.1,1.2.3s.3.6.3,1.2v3.3c0,.6-.1,1-.3,1.2s-.6.3-1.2.3h-4.6c-.6,0-1-.1-1.2-.3s-.3-.6-.3-1.2V1.5ZM10,5h4.8V1.1h-4.8v3.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,6.2V0h1l4.4,3.7c.1.1.3.2.4.3s.2.2.3.3c0-.3,0-.6,0-.7s0-.3,0-.3V0h1.3v6.2h-1l-4.5-3.8c-.1,0-.2-.2-.3-.3s-.2-.2-.2-.2c0,.2,0,.4,0,.5s0,.3,0,.4v3.3h-1.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.1,1.1h-4.5v3.9h4.5v-1.4h-2.4v-1.1h3.8v2.1c0,.6-.1,1-.3,1.2s-.6.3-1.2.3h-4.3c-.6,0-1-.1-1.2-.3s-.3-.6-.3-1.2V1.5c0-.6.1-.9.3-1.2s.6-.3,1.2-.3h4.3c.6,0,1,.1,1.2.3s.3.6.3,1.1h0c0,.1-1.4.4-1.4.4v-.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.3,6.2V0h5.3c.5,0,.8,0,1.1.3s.3.5.3.9v.8c0,.3,0,.5-.3.7s-.4.3-.8.3c.4,0,.6.2.8.4s.3.5.3.8v.8c0,.4-.2.7-.5.9s-.8.3-1.4.3h-4.9ZM41,1h-3.3v1.5h3.3c.2,0,.4,0,.5,0s.1-.2.1-.3v-.6c0-.2,0-.3-.1-.3s-.3-.1-.5-.1ZM41,3.5h-3.3v1.6h3.3c.3,0,.5,0,.6-.1s.1-.2.1-.4v-.5c0-.2,0-.4-.1-.4s-.3-.1-.6-.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.5,1.5c0-.6.1-.9.3-1.2s.6-.3,1.2-.3h4.6c.6,0,1,.1,1.2.3s.3.6.3,1.2v3.3c0,.6-.1,1-.3,1.2s-.6.3-1.2.3h-4.6c-.6,0-1-.1-1.2-.3s-.3-.6-.3-1.2V1.5ZM46,5h4.8V1.1h-4.8v3.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.9,1.5c0-.6.1-.9.3-1.2s.6-.3,1.2-.3h4.6c.6,0,1,.1,1.2.3s.3.6.3,1.2v3.3c0,.6-.1,1-.3,1.2s-.6.3-1.2.3h-4.6c-.6,0-1-.1-1.2-.3s-.3-.6-.3-1.2V1.5ZM55.3,5h4.8V1.1h-4.8v3.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.3,6.2V0h1.5v2.6l3.4-2.6h2.1l-4.1,2.9,4.6,3.3h-2.3l-3.7-2.7v2.7h-1.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77,1.1h-4.1v1.3h3.9c.6,0,1,.1,1.2.3s.3.6.3,1.2v.8c0,.6-.1.9-.3,1.2s-.6.3-1.2.3h-3.8c-.6,0-1-.1-1.2-.3s-.3-.6-.3-1.2v-.2l1.3-.3v.7h4.4v-1.4h-3.9c-.6,0-1-.1-1.2-.3s-.3-.6-.3-1.2v-.7c0-.6.1-.9.3-1.2s.6-.3,1.2-.3h3.5c.6,0,1,0,1.2.3s.3.6.3,1.1h0c0,.1-1.3.4-1.3.4v-.7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81,4.3h.2c.1,0,.2,0,.2,0s0,.2,0,.3v1c0,.2,0,.3,0,.4s-.2,0-.4,0h-1.1c-.1,0-.2,0-.2,0s0-.2,0-.4v-1c0-.2,0-.3,0-.4s.2,0,.4,0h.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongbooksLogo);
export default __webpack_public_path__ + "static/media/songbooks-logo.c75f9d147ac95bee5cb1715b8a084e0c.svg";
export { ForwardRef as ReactComponent };